// extracted by mini-css-extract-plugin
module.exports = {"main":"e_Ee","gdrInfo":"e_Fe","gdrLink":"e_Ge","gdrButton":"e_He"};